import { FieldType, FormControlModel, GroupList, PROMPTS, WidthClass } from '@thehubz/client/core';
import { Asset } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';
import { getDriveListSEAT, getSpecialModelListSEAT, getTrimListSEAT } from '../customer-metadata-config';

export const BRANDMARKE = [
  { _id: 'seat', name: 'SEAT' },
  { _id: 'cupra', name: 'CUPRA' },
];

export const MEDIATYPE: GroupList[] = [
  {
    lists: [
      { _id: 'CGI', name: 'CGI' },
      { _id: 'Lifestyle', name: 'Lifestyle' },
      { _id: 'People', name: 'People' },
      { _id: 'Produkt', name: 'Produkt' },
      { _id: 'Shooting', name: 'Shooting' },
      { _id: 'sonstigeBilder', name: 'Sonstige Bilder' },
    ],
    name: $localize`Image`,
  },
  {
    lists: [
      { _id: 'Image/Brand', name: 'Image/Brand' },
      { _id: 'sonstigeVideos', name: 'Sonstige Videos' },
      { _id: 'Produkt_video', name: 'Produkt' },
    ],
    name: $localize`Video`,
  },
];

export const CHANNELS = [
  { _id: 'allMedia', name: 'All media' },
  { _id: 'Kino', name: 'Kino' },
  { _id: 'Messe/Event', name: 'Messe/Event' },
  { _id: 'Online/Digital', name: 'Online/Digital' },
  { _id: 'OOH', name: 'OOH' },
  { _id: 'POS', name: 'POS' },
  { _id: 'Print', name: 'Print' },
  { _id: 'socialMedia', name: 'Social Media' },
  { _id: 'TV', name: 'TV' },
];

/**
 * SEAT general information forms
 * @returns
 */
export const seatGeneralInformationFields = (taxonomyOptions?: AnyType[]): FormControlModel[] => [
  {
    formTypeId: '1',
    formFieldName: 'name',
    fieldType: FieldType.Text,
    fieldLabel: $localize`Asset name`,
    placeholder: $localize`:placeholder:Asset name`,
    inputType: 'text',
    disable: true,
    validators: {
      required: true,
    },
    widthClass: WidthClass.WFull,
    value: '',
    visible: true,
  },
  {
    formTypeId: '2',
    formFieldName: 'status',
    fieldType: FieldType.Dropdown,
    fieldLabel: $localize`Status`,
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    widthClass: WidthClass.W12,
    validators: {
      required: true,
    },
    value: '',
    options: [
      { _id: Asset.StatusEnum.Uploaded, name: $localize`Uploaded` },
      { _id: Asset.StatusEnum.Approved, name: $localize`Approved` },
      { _id: Asset.StatusEnum.Archived, name: $localize`Archived` },
      { _id: Asset.StatusEnum.AwaitingApproval, name: $localize`Awaiting approval` },
    ],
    visible: true,
  },
  {
    formTypeId: '3',
    formFieldName: 'domains',
    fieldType: FieldType.FormArray,
    fieldLabel: $localize`Domains`,
    hideLabel: true,
    widthClass: WidthClass.WFull,
    visible: true,
    formFieldGroup: [
      {
        formTypeId: '3_1',
        formFieldName: 'agency',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Agency`,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        widthClass: WidthClass.W12,
        repeatFieldLabel: true,
        validators: {
          required: true,
        },
        value: undefined,
        dropDownSearch: true,
        options: [],
        visible: false,
      },
      {
        formTypeId: '3_2',
        formFieldName: 'client',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Client`,
        repeatFieldLabel: true,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        widthClass: WidthClass.W12,
        validators: {
          required: true,
        },
        value: undefined,
        dropDownSearch: true,
        options: [],
        visible: false,
        nestedOptions: {},
      },
      {
        formTypeId: '3_3',
        formFieldName: 'brand',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Brand`,
        repeatFieldLabel: true,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        widthClass: WidthClass.W12,
        validators: {
          required: true,
        },
        value: undefined,
        dropDownSearch: true,
        options: [],
        visible: false,
        nestedOptions: {},
      },
      {
        formTypeId: '3_4',
        formFieldName: 'brandMarke',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Marke`,
        repeatFieldLabel: true,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        widthClass: WidthClass.W12,
        value: undefined,
        dropDownSearch: true,
        options: [],
        visible: true,
        nestedOptions: {},
      },
      {
        formTypeId: '3_5',
        formFieldName: 'brandModel',
        fieldType: FieldType.Dropdown,
        fieldLabel: $localize`Model`,
        repeatFieldLabel: true,
        placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
        widthClass: WidthClass.W12,
        value: undefined,
        dropDownSearch: true,
        options: [],
        visible: true,
        nestedOptions: {},
      },
    ],
  },
  {
    formTypeId: '5',
    formFieldName: 'mediaType',
    fieldType: FieldType.MultiSelectChip,
    fieldLabel: 'Medienart',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_MULTIPLE,
    inputType: '',
    mandatory: false,
    enableMatOptGroup: true,
    widthClass: WidthClass.W12,
    disable: false,
    groupListView: true,
    sortDataSource: false,
    visible: true,
    options: MEDIATYPE,
  },
  {
    formTypeId: '6',
    formFieldName: 'channels',
    fieldType: FieldType.MultiSelectChip,
    fieldLabel: 'Kanäle',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_MULTIPLE,
    inputType: '',
    mandatory: true,
    widthClass: WidthClass.W12,
    sortDataSource: false,
    disable: false,
    visible: true,
    options: CHANNELS,
  },
  {
    formTypeId: '10',
    formFieldName: 'plannedDeletionToggle',
    fieldType: FieldType.Checkbox,
    fieldLabel: $localize`Planned for deletion`,
    placeholder: '',
    widthClass: WidthClass.W13,
    editOnly: true,
    value: '',
    visible: true,
  },
  {
    formTypeId: '11',
    formFieldName: 'plannedDeletion',
    fieldType: FieldType.Date,
    fieldLabel: $localize`Deletion date`,
    placeholder: $localize`DD/MM/YYYY`,
    minDate: new Date(),
    widthClass: WidthClass.W13,
    value: '',
    disable: true,
    editOnly: true,
    validators: {
      required: true,
    },
    visible: true,
  },
];

export const seatContentDescriptionFields = (taxonomyOptions?: AnyType): FormControlModel[] => [
  {
    formTypeId: '13',
    formFieldName: 'date-label',
    fieldLabel: 'Kurzbeschreibung',
    fieldType: FieldType.Label,
    placeholder: '',
    visible: true,
    fieldAssociated: ['shortDescription'],
    widthClass: '' + WidthClass.WFull + ' seatTextColor',
  },
  {
    formTypeId: '2',
    formFieldName: 'shortDescription',
    fieldType: FieldType.Textarea,
    fieldLabel: 'Was ist auf dem Bild/in dem Video zu sehen?',
    placeholder: 'Was ist auf dem Bild/in dem Video zu sehen?',
    inputType: 'text',
    widthClass: WidthClass.WFull,
    visible: true,
    value: '',
  },
  {
    formTypeId: '13',
    formFieldName: 'date-label',
    fieldLabel: 'Fahrzeuginformation',
    fieldType: FieldType.Label,
    placeholder: '',
    visible: true,
    fieldAssociated: ['modelYear', 'trim', 'specialModel', 'drive', 'vehicleColor', 'specialFeature'],
    widthClass: '' + WidthClass.WFull + ' seatTextColor',
  },
  {
    formTypeId: '4',
    formFieldName: 'modelYear',
    fieldType: FieldType.Text,
    fieldLabel: 'Modelljahr',
    placeholder: 'Modelljahr',
    inputType: 'text',
    fieldGroup: 'usageRight',
    widthClass: WidthClass.W12,
    value: '',
    visible: true,
  },
  {
    formTypeId: '1',
    formFieldName: 'trim',
    fieldType: FieldType.MultiSelectChip,
    fieldLabel: 'Trim',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_MULTIPLE,
    inputType: '',
    mandatory: false,
    sortDataSource: false,
    widthClass: WidthClass.W12,
    disable: false,
    visible: true,
    options: getTrimListSEAT(),
  },
  {
    formTypeId: '1',
    formFieldName: 'specialModel',
    fieldType: FieldType.Dropdown,
    fieldLabel: 'Sondermodell',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: true,
    sortDataSource: false,
    widthClass: WidthClass.W12,
    disable: false,
    visible: true,
    options: getSpecialModelListSEAT(),
  },
  {
    formTypeId: '1',
    formFieldName: 'drive',
    fieldType: FieldType.Dropdown,
    fieldLabel: 'Antrieb',
    placeholder: PROMPTS.PLACEHOLDER.DROPDOWN_SELECT_ONE,
    inputType: '',
    mandatory: true,
    widthClass: WidthClass.W12,
    disable: false,
    visible: true,
    options: getDriveListSEAT(),
  },
  {
    formTypeId: '4',
    formFieldName: 'vehicleColor',
    fieldType: FieldType.Text,
    fieldLabel: 'Fahrzeugfarbe',
    placeholder: 'Fahrzeugfarbe',
    inputType: 'text',
    fieldGroup: 'usageRight',
    widthClass: WidthClass.W12,
    value: '',
    visible: true,
  },
  {
    formTypeId: '2',
    formFieldName: 'specialFeature',
    fieldType: FieldType.Textarea,
    fieldLabel: 'Besondere Ausstattungsmerkmale',
    placeholder: 'Besondere Ausstattungsmerkmale',
    inputType: 'text',
    widthClass: WidthClass.WFull,
    visible: true,
    value: '',
  },
];

export const seatTaggingNTaxonomyFields = (): FormControlModel[] => [];

export const seatUsageRightsFields = (): FormControlModel[] => [
  {
    formTypeId: '3',
    formFieldName: 'expiryDate',
    fieldType: FieldType.Date,
    fieldLabel: 'Gültigkeit',
    placeholder: $localize`DD/MM/YYYY`,
    minDate: new Date(),
    fieldGroup: 'usageRight',
    mandatory: true,
    validators: {
      required: true,
    },
    widthClass: WidthClass.W14,
    value: '',
    visible: true,
  },
];
